import { wgApi } from '../../../app/src/features/api/wgApi';
import { StatusResponse } from '../../../../types/API';

export const getConversationsQKey = (): string[] => ['/conversations'];

export const patchConversationById = async (
  conversationId: string,
  payload: Record<string, unknown>,
): Promise<number> => {
  const { status } = await wgApi.patch<StatusResponse>(
    `v1/api/conversations/${conversationId}`,
    payload,
  );
  return status;
};
